"use strict";

import { commonConstants, favouritesConstants } from "../_constants";

const getInitialState = () => ({
  favouritesList: [],
  isFavouritesLoading: false,
  isRecentFavouritesLoading: false,
  selectedFavourite: {},
  favouriteActiveTab: favouritesConstants.TRANSACTION_TYPE_ALL,
  recentFavouriteList: [],
  favouritesPayableList: [],
  favouritesPayableListError: false,
  addToFavouritesConfirmation: {},
  favouriteFormTabType: favouritesConstants.FORM_TAB_TYPE_PAY,
  favouriteScreenType: commonConstants.FAVOURITE_ITEM_LIST_TYPE_SCREEN,
  favouriteSelectePaymentOption: {},
  favouritesPayableAccounts: [],
  favouritesPayableCards: [],
  favouriteAmount: 0,
  favouriteOutStandingAmount: 0,
  favouritePayAccountNumber: null,
  favouriteCardType: null,
  favouritePayBalance: null,
  isFavouriteValidateAmountLoading: false,
  favouriteCheckAmountValidation: {},
  favouriteValidateAmountStatus: "",
  favouriteTransactionInfo: {},
  favouriteIsOtpProcessRequired: false,
  favouriteOtpTimerTimePeriod: 0,
  favouriteOtpExpireTime: 0,
  favouriteConfirmationTransactionInfo: {},
  favouritePaymentStatus: "",
  favouriteAccountValidation: {},
  isFavouriteOutstandinAmountLoading: false,
  favouriteDetails: {},
  updateFavourite: {},
  updateFavouriteOtpConfirmationStatus: false,
  deleteFavourite: {},
  deleteFavouriteOtpConfirmationStatus: false,
  isPaginatingFavourites: false,
  selectedNavigationPathName: "",
  favouriteTransactionHistoryList: {
    list: [],
    isEmpty: false,
  },
  updateOtpTimer: 0,
  deleteOtpTimer: 0,
  favouriteTransactionDetail: {},
});

export function favourites(state = getInitialState(), action) {
  switch (action.type) {
    case favouritesConstants.GET_FAVOURITES_LIST_REQUEST:
      return {
        ...state,
        isFavouritesLoading: true,
      };

    case favouritesConstants.GET_FAVOURITES_LIST_COMPLETE:
      return {
        ...state,
        isFavouritesLoading: false,
        favouritesList: state.isPaginatingFavourites
          ? [
              ...state.favouritesList,
              ...action.payload.data?.customerPaymentTemplateList,
            ]
          : action.payload.data?.customerPaymentTemplateList,
      };
    case favouritesConstants.GET_FAVOURITES_LIST_ERROR:
      return {
        ...state,
        isFavouritesLoading: false,
        favouritesList: [],
      };

    case favouritesConstants.FAVOURITE_DETAILS_COMPLETE:
      return {
        ...state,
        favouriteDetails: action.payload.data.dlCustomerPaymentTemplateDto,
      };

    case favouritesConstants.FAVOURITE_DETAILS_ERROR:
      return {
        ...state,
        favouriteDetails: {},
      };

    case favouritesConstants.GET_RECENT_FAVOURITES_LIST_REQUEST:
      return {
        ...state,
        isRecentFavouritesLoading: true,
      };

    case favouritesConstants.GET_RECENT_FAVOURITES_LIST_COMPLETE:
      return {
        ...state,
        isRecentFavouritesLoading: false,
        recentFavouriteList: action.payload.data.customerPaymentTemplateList,
      };

    case favouritesConstants.GET_RECENT_FAVOURITES_LIST_ERROR:
      return {
        ...state,
        isRecentFavouritesLoading: false,
        recentFavouriteList: [],
      };

    case favouritesConstants.CLEAR_ADD_TO_FAVOURITE_CONFIRMATION:
      return {
        ...state,
        addToFavouritesConfirmation: {},
      };
    case favouritesConstants.ADD_TO_FAVOURITES_COMPLETE:
      return {
        ...state,
        addToFavouritesConfirmation: action.payload.data,
      };

    case favouritesConstants.ADD_TO_FAVOURITES_ERROR:
      return {
        ...state,
        addToFavouritesConfirmation: {},
      };

    case favouritesConstants.CLEAR_ADD_TO_FAVOURITE_CONFIRMATION:
      return {
        ...state,
        addToFavouritesConfirmation: {},
      };

    case favouritesConstants.SET_SELECTED_FAVOURITE:
      return {
        ...state,
        selectedFavourite: action.payload,
      };

    case favouritesConstants.SET_IS_PAGINATING_FAVOURITES:
      return {
        ...state,
        isPaginatingFavourites: action.payload,
      };

    case favouritesConstants.SET_SELECTED_PATH_NAME:
      return {
        ...state,
        selectedNavigationPathName: action.payload,
      };

    case favouritesConstants.SET_FAVOURITE_SCREEN_TYPE:
      return {
        ...state,
        favouriteScreenType: action.payload,
      };
    case favouritesConstants.SET_FAVOURITE_SCREEN_TYPE:
      return {
        ...state,
        favouriteScreenType: action.payload,
      };
    case favouritesConstants.SET_FAVOURITES_ACTIVE_TAB:
      return {
        ...state,
        favouriteActiveTab: action.payload,
      };
    case favouritesConstants.SET_FORM_TAB_TYPE:
      return {
        ...state,
        favouriteFormTabType: action.payload,
      };

    case favouritesConstants.SET_FAVOURITE_SELECTED_PAYMENT_OPTION:
      return {
        ...state,
        favouriteSelectePaymentOption: action.payload,
      };

    case favouritesConstants.FAVOURITES_PAYABLE_LIST_COMPLETE:
      return {
        ...state,
        favouritesPayableList: action.payload?.data?.accountList,
        favouritesPayableListError: false,
      };

    case favouritesConstants.FAVOURITES_PAYABLE_LIST_ERROR:
      return {
        ...state,
        favouritesPayableList: [],
        favouritesPayableListError: true,
      };

    case favouritesConstants.SET_FAVOURITE_PAYABE_ACCOUNTS:
      return {
        ...state,
        favouritesPayableAccounts: action.payload,
      };
    case favouritesConstants.SET_FAVOURITE_PAYABE_CARDS:
      return {
        ...state,
        favouritesPayableCards: action.payload,
      };

    case favouritesConstants.SET_FAVOURITE_AMOUNT:
      return {
        ...state,
        favouriteAmount: action.payload,
      };

    case favouritesConstants.SET_FAVOURITE_OUTSTANDING_AMOUNT:
      return {
        ...state,
        favouriteOutStandingAmount: action.payload,
      };

    case favouritesConstants.SET_FAVOURITE_PAY_ACCOUNT_NUMBER:
      return {
        ...state,
        favouritePayAccountNumber: action.payload,
      };

    case favouritesConstants.SET_FAVOURITE_CARD_TYPE:
      return {
        ...state,
        favouriteCardType: action.payload,
      };

    case favouritesConstants.SET_FAVOURITE_PAY_BALANCE:
      return {
        ...state,
        favouritePayBalance: action.payload,
      };

    case favouritesConstants.SET_FAVOURITE_PAYMENT_STATUS:
      return {
        ...state,
        favouritePaymentStatus: action.payload,
      };

    case favouritesConstants.VALIDATE_FAVOURITE_AMOUNT_REQUEST:
      return {
        ...state,
        isFavouriteValidateAmountLoading: true,
      };
    case favouritesConstants.VALIDATE_FAVOURITE_AMOUNT_COMPLETE:
      return {
        ...state,
        isFavouriteValidateAmountLoading: false,
        favouriteCheckAmountValidation: action.payload?.data?.transactionInfo,
        favouriteValidateAmountStatus: "",
      };

    case favouritesConstants.VALIDATE_FAVOURITE_AMOUNT_ERROR:
      return {
        ...state,
        isFavouriteValidateAmountLoading: false,
        favouriteCheckAmountValidation: action.payload?.response?.errorResponse
          ?.transactionInfo
          ? action.payload.response.errorResponse.transactionInfo
          : {},
        favouriteValidateAmountStatus: action.payload.response.statusCode,
      };

    case favouritesConstants.FAVOURITE_PAY_BILL_REQUEST:
      return {
        ...state,
        favouriteTransactionInfo: {},
      };

    case favouritesConstants.CLEAR_FAVOURITE_AMOUNT_VALIDATION_STATUS:
      return {
        ...state,
        favouriteValidateAmountStatus: "",
      };

    case favouritesConstants.FAVOURITE_PAY_BILL_COMPLETE:
      return {
        ...state,
        favouriteIsOtpProcessRequired:
          action.payload?.data?.isOtpProcessRequired,
        favouriteOtpTimerTimePeriod: action.payload?.data?.otpTimerTimePeriod,
        favouriteOtpExpireTime: action.payload?.data?.otpExpireTime,
        favouriteTransactionInfo: action.payload?.data?.transactionInfo,
      };

    case favouritesConstants.FAVOURITE_PAY_BILL_ERROR:
      return {
        ...state,
        favouriteConfirmationTransactionInfo:
          action.payload?.response?.errorResponse?.transactionInfo ?? {},
      };

    case favouritesConstants.TRY_AGAIN_FAVOURITE_PAYMENT:
      return {
        ...state,
        favouriteCheckAmountValidation: {},
        favouriteConfirmationTransactionInfo: {},
        favouriteTransactionInfo: {},
      };

    case favouritesConstants.FAVOURITE_OUTSTANDING_AMOUNT_REQUEST:
      return {
        ...state,
        isFavouriteOutstandinAmountLoading: true,
      };
    case favouritesConstants.FAVOURITE_OUTSTANDING_AMOUNT_COMPLETE:
      return {
        ...state,
        favouriteValidateAmountStatus: "",
        favouriteAccountValidation:
          action.payload?.data?.spiderBillerValidateResponse,
        isFavouriteOutstandinAmountLoading: false,
      };

    case favouritesConstants.FAVOURITE_OUTSTANDING_AMOUNT_ERROR:
      return {
        ...state,
        favouriteValidateAmountStatus: action.payload?.response?.statusCode,
        favouriteAccountValidation: {},
        isFavouriteOutstandinAmountLoading: false,
      };

    case favouritesConstants.UPDATE_FAVOURITE_REQUEST:
      return {
        ...state,
        updateFavourite: {},
        updateOtpTimer: 0,
      };
    case favouritesConstants.UPDATE_FAVOURITE_COMPLETE:
      return {
        ...state,
        updateFavourite: action.payload?.data,
        updateOtpTimer: action.payload?.data?.otpTimerTimePeriod,
      };

    case favouritesConstants.UPDATE_FAVOURITE_ERROR:
      return {
        ...state,
        updateFavourite: action.payload?.response?.errorResponse,
        updateOtpTimer:
          action.payload?.response?.errorResponse?.errorResponse?.remainingTime,
      };

    case favouritesConstants.DELETE_FAVOURITE_REQUEST:
      return {
        ...state,
        deleteFavourite: {},
        deleteOtpTimer: 0,
      };
    case favouritesConstants.DELETE_FAVOURITE_COMPLETE:
      return {
        ...state,

        deleteFavourite: action.payload?.data,
        deleteOtpTimer: action.payload?.data?.otpTimerTimePeriod,
      };

    case favouritesConstants.DELETE_FAVOURITE_ERROR:
      return {
        ...state,
        deleteFavourite: {},
        deleteOtpTimer: 0,
      };

    case favouritesConstants.FAVOURITE_OTP_CONFIRMATION_COMPLETE:
      return {
        ...state,
        updateFavouriteOtpConfirmationStatus: true,
        deleteFavouriteOtpConfirmationStatus: true,
        updateFavourite: {},
        deleteFavourite: {},
        updateOtpTimer: 0,
        deleteOtpTimer: 0,
        addOtpTimer: 0,
        addFavouriteOtpConfirmationStatus: true,
      };

    case favouritesConstants.FAVOURITE_OTP_CONFIRMATION_ERROR:
      return {
        ...state,
      };

    case favouritesConstants.FAVOURITE_OTP_RESEND_COMPLETE:
      return {
        ...state,
        updateFavourite: {},
        deleteFavourite: {},
      };

    case favouritesConstants.FAVOURITE_OTP_RESEND_ERROR:
      return {
        ...state,
      };

    case favouritesConstants.SET_OTP_CONFIRNATION_STATUS:
      return {
        ...state,
        updateFavouriteOtpConfirmationStatus: action.payload,
        deleteFavouriteOtpConfirmationStatus: action.payload,
      };

    case favouritesConstants.FAVOURITE_TRANSACTION_HISTORY_LIST_COMPLETE:
      let empty = false;
      if (
        Array.isArray(action.payload?.list) &&
        action.payload?.list?.length === 0
      ) {
        empty = true;
      }

      return {
        ...state,
        favouriteTransactionHistoryList: !action.payload.isFiltering
          ? {
              list: [
                ...state.favouriteTransactionHistoryList.list,
                ...action.payload.list,
              ],
              isEmpty: empty,
            }
          : {
              list: [...action.payload.list],
              isEmpty: empty,
            },
      };

    case favouritesConstants.FAVOURITE_TRANSACTION_HISTORY_DETAIL_COMPLETE:
      return {
        ...state,
        favouriteTransactionDetail: {
          ...action.payload,
        },
      };
    case favouritesConstants.CLEAR_FAVOURITE:
      // Preserve selected favourites tab so returning to the list keeps context.
      return {
        ...getInitialState(),
        favouriteActiveTab:
          state.favouriteActiveTab ?? favouritesConstants.TRANSACTION_TYPE_ALL,
      };

    case favouritesConstants.CLEAR_FAVOURITE_ACTIVE_TAB:
      return {
        ...state,
        favouriteActiveTab: favouritesConstants.TRANSACTION_TYPE_ALL,
      };

    case favouritesConstants.CLEAR_FAVOURITE_LIST:
      return {
        ...state,
        favouritesList: [],
      };
  }

  return state;
}
